import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import CustomTextField from "../../../shared/textFields/CustomTextField";

import { ToastContainer } from "react-toastify";
import CustomAutoComplete from "../../../shared/autoCompletes/CustomAutoComplete";
import CustomLoadingButton from "../../../shared/button/CustomLoadingButton";
import CustomDialog from "../../../shared/dialog/CustomDialog";
import { FormatMoney } from "../../../shared/format/Formats";
import FormatedCustomTextField from "../../../shared/textFields/FormatedCustomTextField";
import usePowerDistributionCompanyForm from "../controller";
import useEditPowerDistributionCompany from "./controller";
import { PowerDistributionCompanyChecklist } from "../Checklist";

export default function EditPowerDistributionCompany({ initialPowerDistributionId, onSuccess, layout = "horizontal" }) {
  const formController = usePowerDistributionCompanyForm(initialPowerDistributionId);
  const controller = useEditPowerDistributionCompany(formController, onSuccess);

  const isVertical = layout === "vertical";

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        height: "auto",
        minHeight: isVertical ? "auto" : 450,
      }}
    >
      <ToastContainer />

      <CustomDialog
        open={controller.open}
        handleClickClose={controller.handleClickClose}
        title="Excluir Concessionária"
        contentText="As informações da concessionária serão excluídas e não poderão ser recuperadas."
        requestLoading={controller.deleteRequestLoading}
        handleConfirmationClick={controller.handleDeleteClick}
        confirmationClickText="Excluir"
        requestLoadingText="Excluindo..."
      />

      {formController.powerDistributionCompany.value ? (
        <Box
          sx={{
            mt: 2,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            p: 2,
            justifyContent: "space-between",
            borderRadius: 3,
            height: "auto",
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: isVertical ? "column" : "row",
              justifyContent: "space-between",
              gap: isVertical ? 2 : 0,
            }}
          >
            <Box
              sx={{
                width: isVertical ? "100%" : "45%",
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
                gap: 2,
              }}
            >
              <CustomTextField
                params={formController.powerDistributionCompanyName}
                disabled={controller.isDisabled}
                label="Nome da Concessionária"
                errorLabel="Nome Incorreto"
                maxLength={30}
              />
              <CustomAutoComplete
                params={formController.state}
                options={formController.apiStates}
                disabled={controller.isDisabled}
                label="Estado"
                width="100%"
              />
              <CustomAutoComplete
                params={formController.engineer}
                options={formController.apiEngineers}
                disabled={controller.isDisabled}
                label="Engenheiro Padrão"
                width="100%"
              />
            </Box>
            <Box
              sx={{
                width: isVertical ? "100%" : "45%",
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
                gap: 2,
              }}
            >
              <FormControlLabel
                control={<Checkbox checked={formController.hasProcessing.checked} onChange={formController.hasProcessing.onChange} />}
                label="Possui processamento?"
                labelPlacement="start"
              />
              <Box display="flex" sx={{ justifyContent: "space-between" }}>
                <FormControlLabel
                  control={<Checkbox checked={formController.hasADifferentPrice.checked} onChange={formController.hasADifferentPrice.onChange} />}
                  label="Outro Valor de ART?"
                  labelPlacement="start"
                />
                <FormatedCustomTextField
                  params={formController.price}
                  disabled={!formController.hasADifferentPrice.checked}
                  label="Valor"
                  errorLabel="Valor Incorreto"
                  inputcomponent={FormatMoney}
                  required={false}
                  width="45%"
                />
              </Box>
            </Box>
          </Box>

          {/* Checklist da Empresa Distribuidora */}
          <Box sx={{ mt: 4, width: "100%" }}>
            <PowerDistributionCompanyChecklist
              pdcId={formController.powerDistributionCompany.value.id}
              initializeLoadingToast={formController.initializeLoadingToast}
              updateLoadingToast={formController.updateLoadingToast}
            />
          </Box>

          <Box
            display="flex"
            width="45%"
            sx={{
              justifyContent: "space-between",
              alignSelf: "flex-end",
              mt: 5,
            }}
          >
            <Button
              variant="outlined"
              color="error"
              sx={{
                width: "45%",
              }}
              disabled={controller.updateRequestLoading || controller.deleteRequestLoading}
              onClick={controller.handleClickOpen}
            >
              Excluir
            </Button>

            <CustomLoadingButton
              buttonText="Atualizar"
              buttonLoadingText="Atualizando..."
              sx={{ width: "45%" }}
              disabled={controller.requestLoading || controller.deleteRequestLoading}
              handleButtonClick={controller.handleUpdateClick}
              requestLoading={controller.requestLoading}
            />
          </Box>
        </Box>
      ) : null}
    </Box>
  );
}
